import { DataSort } from '../models/configuration/DataSort';
import get from 'lodash/get';

export const sortDate = (a: string | number, b: string | number) => {
    const aDate = new Date(a);
    const bDate = new Date(b);

    return Number(aDate) - Number(bDate);
};

export const sortNumber = (a: number, b: number) => {
    return a - b;
};

export const sortString = (a: string, b: string) => {
    const aString = a.toString().toUpperCase();
    const bString = b.toString().toUpperCase();

    if (aString > bString) {
        return 1;
    }

    if (aString < bString) {
        return -1;
    }

    return 0;
};

export const sortValues = (values: Array<any>, config: DataSort) => {
    if (values && values.length > 0) {
        values = values.sort((a, b) => getSortResult(a, b, config));

        // Sort direction
        if (config?.direction === 'DESC') {
            values = values.reverse();
        }

        // Sort by a specified order
        if (config?.order?.length > 0) {
            values = values
                .map(value => {
                    const orderIndex = config.order.indexOf(value[config.key]);
                    value.order =
                        orderIndex > -1 ? orderIndex : config.order.length;
                    return value;
                })
                .sort((a, b) => sortNumber(a.order, b.order));
        }
    }
    return values;
};

/**
 * @title Order By
 * @param values are the records that need to be sorted
 * @param config is an array of DataSort where the order within the array determines the precedence of the sort
 */
export const orderBy = (values: Array<any>, config: Array<DataSort>) => {
    if (values?.length > 0) {
        values = values.sort(fieldSorter(config));
    }
    return values;
};

const fieldSorter = (configs: Array<DataSort>) => {
    const directory = [];
    const length = configs.length;
    configs.forEach((config, index) => {
        directory[index] = config.direction === 'DESC' ? -1 : 1;
    });

    return (a, b) => {
        for (let i = 0; i < length; i++) {
            const config = configs[i];
            const result = getSortResult(a, b, config);

            // Based on the result, use the config directory to determine precedence based on other configs
            if (result === 1) {
                return directory[i];
            }
            if (result === -1) {
                return -directory[i];
            }
        }
        return 0;
    };
};

const getSortResult = (a: any, b: any, config: DataSort) => {
    let result = 0;
    if (config?.type === 'date') {
        result = sortDate(
            get(a, config.key, '2099-01-01'),
            get(b, config.key, '2099-01-01')
        );
    }

    if (config?.type === 'string') {
        result = sortString(get(a, config.key, '~'), get(b, config.key, '~'));
    }

    if (config?.type === 'number') {
        result = sortNumber(
            get(a, config.key, Number.MAX_VALUE),
            get(b, config.key, Number.MAX_VALUE)
        );
    }
    return result;
};



// WEBPACK FOOTER //
// ./src/utils/sort.ts